<template>
   <div class="form">
      <template  v-if="!form.sended">
      <div class="title">Написать</div>
      <form @submit.prevent="create">
         <input
            type="text"
            placeholder="Имя"
            name="name"
            v-model='form.name'
            :class="{ error: v$.form.name.$errors.length }"
         >

<!--         <input -->
<!--            type="text"-->
<!--            placeholder="Телефон" -->
<!--            name="contact"-->
<!--            v-model='form.contact'-->
<!--            :class="{ error: v$.form.contact.$errors.length }"-->
<!--         >-->
          <div class="input wrapper-input__phone-field" :class="{'bad-field':v$.form.contact.$errors.length}">
              <div class="phone-code">+7</div>
              <input
                  autocomplete="tel"
                  max-length="12"
                  v-phone
                  v-model="form.contact"
                  placeholder="Телефон">
          </div>

         <textarea
            placeholder="Написать сообщение"
            name="message"
            v-model='form.message'
            :class="{ error: v$.form.message.$errors.length }"
         ></textarea>

         <label class="checkbox" >
            <input type="checkbox" v-model='form.rules' :class="{ error: v$.form.rules.$errors.length }">
            <span class="checkbox__text" :class="{ error: v$.form.rules.$errors.length }">Даю согласие c политикой обработки персональных данных</span>
         </label>

         <div class="form-wrapper-error">
            <div :class="{ error: v$.form.name.$errors.length }">
               <div class="input-errors" v-for="error of v$.form.name.$errors" :key="error.$uid">
                  <div v-if="error.$validator == 'required'">Поле Имя: обязательно для заполнения</div>
                  <div v-if="error.$validator == 'minLength'">Поле Имя: слишком короткое</div>
               </div>
            </div>

            <div :class="{ error: v$.form.contact.$errors.length }">
               <div class="input-errors" v-for="error of v$.form.contact.$errors" :key="error.$uid">
                  <div v-if="error.$validator == 'required'">Поле Телефон: обязательно для заполнения</div>
                  <div v-if="error.$validator == 'minLength'">Поле Телефон: слишком короткое</div>
               </div>
            </div>

            <div :class="{ error: v$.form.message.$errors.length }">
               <div class="input-errors" v-for="error of v$.form.message.$errors" :key="error.$uid">
                  <div v-if="error.$validator == 'required'">Поле Сообщение: обязательно для заполнения</div>
                  <div v-if="error.$validator == 'minLength'">Поле Сообщение: слишком короткое</div>
               </div>
            </div>
            <div :class="{ error: v$.form.rules.$invalid }">
               <div class="input-errors">
                  <div v-if="v$.form.rules.$errors.length">Поле Согласия: обязательно для выбора</div>
               </div>
            </div>
         </div>

         <button class="btn-white" type="submit"><span>Отправить</span></button>
      </form>
      </template>
      <template v-else>
          <div class="title">Заявка отправлена!</div>
      </template>
   </div>
</template>

<script>
import fn from "../../js/fn";
import useVuelidate from '@vuelidate/core'
import PhoneMask from "../vue-components/directives/PhoneMaskNotSeven"
import { required, minLength } from '@vuelidate/validators'

export default {
   name: "Question",
    directives: {
        'phone': PhoneMask
    },
   setup: () => ({ v$: useVuelidate() }),
   validations() {
      return {
         form: {
               name: {
                  required,
                  minLength: minLength(4)
               },
               contact: {
                  required,
                  minLength: minLength(13)
               },
               message: {
                  required,
                  minLength: minLength(18),
               },
               rules: {
                  checked: (val) => {return val;}
               }
         }
      }
   },

   data() {
      return {
         form: {
               name: null,
               contact: null,
               message: null,
               rules: false,
               sended: false
         },
      }
   },

   mounted() {
   },

   methods: {
      async create() {
         const result = await this.v$.$validate()

         if (result) {
            fn.sync({
               url: '/zen/project/api/questions:make',
               data: { form:this.form },
               then: response => {
                  this.form.sended = true;
               }
            })
         }
      }
   }
}
</script>
